import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-error-flag.title',
		defaultMessage: "We couldn't add you to {product}",
		description: 'Title of invite error flag',
	},
	description: {
		id: 'cross-join-nudges.request-access-error-flag.description-support-link',
		defaultMessage:
			"Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
		description: 'Description informing the user that request to join was not successfully sent',
	},
});
